import React, { useEffect, useState } from 'react';
import { getPersonalizedMessages } from '../../utility/personalizedMessages';
import { Col, Row, CaptionText } from '@paypalcorp/pp-react';
import { PPGF_DISCLAIMER_TOUCHPOINT } from '../../utility/constants';

export default function Disclaimer() {
  const [text, setText] = useState(null);

  useEffect(() => {
    const touchpoint = getPersonalizedMessages(PPGF_DISCLAIMER_TOUCHPOINT);
    if (!touchpoint || !touchpoint.messages) {
      return;
    }
    let disclaimerText = '';
    touchpoint.messages.forEach((message) => {
      if (message.content?.json) {
        Object.keys(message.content.json)
          .sort()
          .forEach(
            (key) => (disclaimerText += `${message.content.json[key]} `)
          );
      }
    });
    setText(disclaimerText);
  }, []);

  if (!text) {
    return null;
  }
  return (
    <Row
      style={{
        maxWidth: '400px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <Col sm={12}>
        <CaptionText className="legal-text" size="sm">
          {text}
        </CaptionText>
      </Col>
    </Row>
  );
}
